import { CATEGORIES, NAV_LINKS } from "@/mocks/gossip";

const SOCIALS = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-mail-line", label: "邮件" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-primary-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[4fr_3fr_3fr_3fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-accent-400 to-primary-400 text-lg font-bold text-primary-950">
                瓜
              </span>
              <span className="font-heading text-xl font-bold text-background-50">今日瓜报</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200">
              专注吃瓜事件盘点与合集时间线的内容站。让明星瓜与行业瓜按顺序排列，把来龙去脉讲清楚，让每一个想一口气吃完完整瓜的新老粉都有清晰的找料路径。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-700 text-primary-100 transition-colors hover:border-accent-400 hover:bg-accent-400 hover:text-primary-950"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a href={l.anchor} className="text-sm text-primary-200 transition-colors hover:text-accent-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">瓜田分类</h4>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {CATEGORIES.filter((c) => c.id !== "all").map((c) => (
                <li key={c.id}>
                  <a href="#collections" className="inline-flex items-center gap-1.5 text-sm text-primary-200 transition-colors hover:text-accent-300">
                    <i className="ri-arrow-right-s-line text-accent-400" />
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">联系方式</h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-400" />
                tipline@jingri-guabao.example
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-feedback-line text-accent-400" />
                在线线索区随时可提交
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-accent-400" />
                全天候追踪 · 事件完结即归档
              </li>
            </ul>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-accent-400 px-6 py-2.5 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-300"
            >
              <i className="ri-notification-3-line mr-2" />
              订阅更新提醒
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-primary-300 sm:flex-row md:px-6">
          <p>© 2026 今日瓜报 · 坚持整理公开、可回溯的吃瓜事件信息。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-leaf-line text-accent-400" />
            内容仅供信息整理与讨论，不代表对任何当事人的判断
          </p>
        </div>
      </div>
    </footer>
  );
}